import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './SALEPROFIT_Risk_Score.css';

const SALEPROFIT_Risk_Score = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"SALEPROFIT_RISK_SCORE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	SALEPROFIT_RISK_SCORE:-1
  });


  const [SALEPROFIT_RISK_SCORE, setSALEPROFIT_RISK_SCORE] = React.useState(null);
  const [SALEPROFIT_RISK_SCORE_D, setSALEPROFIT_RISK_SCORE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Sale Profit Token Risk Score');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewSALEPROFIT_RISK_SCORE(clientInfo,"OpenNew");

		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutSALEPROFIT_RISK_SCORE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostSALEPROFIT_RISK_SCORE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewSALEPROFIT_RISK_SCORE(clientInfo,"OpenNew");
		}
		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
		if(Temp_Data2.status!="New"){
			handleDeleteSALEPROFIT_RISK_SCORE(Temp_Data2);
			navigate('/SALEPROFIT_Risk_Score#New',{replace:true});
		} 
		else 
			navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/SALEPROFIT_Risk_Score',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!SALEPROFIT_RISK_SCORE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_${i}_SECTION`;
	  const headerId = `#SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');
    if ($('#Table3').length > 0) window.DataTableScript('#Table3');

    initRef.current.dataTableHandled = true;
  }  

  }, [SALEPROFIT_RISK_SCORE]) ;


  
  
  var Ids = [];
  for(var Ele in SALEPROFIT_RISK_SCORE){
	  for(var Sec in SALEPROFIT_RISK_SCORE[Ele]){
		if(Sec == "id")
			Ids.push(SALEPROFIT_RISK_SCORE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(SALEPROFIT_RISK_SCORE[Ele]["status"]);
		else if(Array.isArray(SALEPROFIT_RISK_SCORE[Ele][Sec]))
			  for(var Row in SALEPROFIT_RISK_SCORE[Ele][Sec])  // Convert to SALEPROFIT_RISK_SCORE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in SALEPROFIT_RISK_SCORE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["SALEPROFIT_RISK_SCORE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewSALEPROFIT_RISK_SCORE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE`).then((response1) => {
		if(!SALEPROFIT_RISK_SCORE) 
			setSALEPROFIT_RISK_SCORE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE_D`).then((response2) => {
			setSALEPROFIT_RISK_SCORE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddSALEPROFIT_RISK_SCORE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewSALEPROFIT_RISK_SCORE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setSALEPROFIT_RISK_SCORE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataSALEPROFIT_RISK_SCORE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutSALEPROFIT_RISK_SCORE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostSALEPROFIT_RISK_SCORE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteSALEPROFIT_RISK_SCORE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/SALEPROFIT_RISK_SCORE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3"]=value;
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["1"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("1","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["4"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("4","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["5"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("5","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["5"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("5","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["5"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("5","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["5"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("5","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["5"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4"]=value;
	Form_Data_onChange("5","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["5"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("5","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0"]=value;
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  
    
const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["9"]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4"]=value;
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
	Form_Data_onChange("9","SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4",value,Temp_Data);
 	//handleLastDataSALEPROFIT_RISK_SCORE(Temp_Data);
    setSALEPROFIT_RISK_SCORE(Temp_Data);
 }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));  
  Temp_Data['2'][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0"] = value;
  setSALEPROFIT_RISK_SCORE(Temp_Data);
};


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["2"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["2"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["2"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["2"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));  
  Temp_Data['3'][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0"] = value;
  setSALEPROFIT_RISK_SCORE(Temp_Data);
};


const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["3"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["3"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["3"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  

const SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
	Temp_Data["3"][index]["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4"]=value;
    setSALEPROFIT_RISK_SCORE(Temp_Data);
	//handleAddSALEPROFIT_RISK_SCORE(Temp_Data,App_Data['SALEPROFIT_RISK_SCORE']);
  }; 
  



 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!SALEPROFIT_RISK_SCORE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4']='';
	    break;
	  case('3'):
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3']='';
	    newRow['SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4']='';
	    break;

  }


  const updatedSALEPROFIT_RISK_SCORE =JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
  updatedSALEPROFIT_RISK_SCORE[Sec] = [...updatedSALEPROFIT_RISK_SCORE[Sec], newRow];
  setSALEPROFIT_RISK_SCORE(updatedSALEPROFIT_RISK_SCORE);
};

const handleDeleteRow = (sec,index) => {
  const updatedSALEPROFIT_RISK_SCORE = JSON.parse(JSON.stringify(SALEPROFIT_RISK_SCORE));
  updatedSALEPROFIT_RISK_SCORE[sec].splice(index, 1);
  setSALEPROFIT_RISK_SCORE(updatedSALEPROFIT_RISK_SCORE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Sale Profit Token Risk Score`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Sale Profit Token Risk Score ID`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`SALEPROFIT Risk Score ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0" type="text" className="form-control" placeholder="SALEPROFIT Risk Score ID" value={SALEPROFIT_RISK_SCORE["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter SALEPROFIT Risk Score ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1" type="text" className="form-control" placeholder="Asset ID" value={SALEPROFIT_RISK_SCORE["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2" type="text" className="form-control" placeholder="Offering ID" value={SALEPROFIT_RISK_SCORE["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Type Code`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3"  value={SALEPROFIT_RISK_SCORE["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_3_Change} className="form-control" name="Token Type Code"  >
						  <option value="RENT_INCOME_TOKEN">RENT_INCOME_TOKEN</option>
						  <option value="REVENUE_SHARE_TOKEN">REVENUE_SHARE_TOKEN</option>
						  <option value="SALE_PROFIT_TOKEN">SALE_PROFIT_TOKEN</option>
						  <option value="EQUITY_APPRECIATION_TOKEN">EQUITY_APPRECIATION_TOKEN</option>
						  <option value="PREFERRED_EQUITY_TOKEN">PREFERRED_EQUITY_TOKEN</option>
						  <option value="COMMON_EQUITY_TOKEN">COMMON_EQUITY_TOKEN</option>
						  <option value="DEBT_NOTE_TOKEN">DEBT_NOTE_TOKEN</option>
						  <option value="HYBRID_TOKEN">HYBRID_TOKEN</option>
						  <option value="PRE_AUCTION_POOL_TOKEN">PRE_AUCTION_POOL_TOKEN</option>
						  <option value="POST_AUCTION_TOKENIZATION">POST_AUCTION_TOKENIZATION</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Type Code
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Overall Risk Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4" type="text" className="form-control" placeholder="Overall Risk Percentage" value={SALEPROFIT_RISK_SCORE["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Overall Risk Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Risk Color ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5" type="text" className="form-control" placeholder="Risk Color ID" value={SALEPROFIT_RISK_SCORE["1"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_1_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Risk Color ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_HEADER">{t(`Risk Factor Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Risk Factor Type`)}</th>
                        <th>{t(`Legal Risk Percentage`)}</th>
                        <th>{t(`Title Risk Percentage`)}</th>
                        <th>{t(`Market Risk Percentage`)}</th>
                        <th>{t(`Liquidity Risk Percentage`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {SALEPROFIT_RISK_SCORE['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0"  onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0_Change(ev, i)}  className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_0`]} name="Risk Factor Type">
						  <option value="Title">Title</option>
						  <option value="Legal">Legal</option>
						  <option value="Market">Market</option>
						  <option value="Liquidity">Liquidity</option>
						  <option value="Income">Income</option>
						  <option value="Construction">Construction</option>
						  <option value="Developer">Developer</option>
						  <option value="Auction">Auction</option>
						  <option value="Redemption">Redemption</option>
						  <option value="Occupancy">Occupancy</option>
						  <option value="Repair">Repair</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_1`]} placeholder="Legal Risk Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_2`]} placeholder="Title Risk Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_3`]} placeholder="Market Risk Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_2_4`]} placeholder="Liquidity Risk Percentage"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_HEADER">{t(`Risk Factor Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('3')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table3" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Risk Factor Type`)}</th>
                        <th>{t(`Income Risk Percentage`)}</th>
                        <th>{t(`Construction Risk Percentage`)}</th>
                        <th>{t(`Developer Risk Percentage`)}</th>
                        <th>{t(`Auction Risk Percentage`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {SALEPROFIT_RISK_SCORE['3'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0"  onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0_Change(ev, i)}  className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_0`]} name="Risk Factor Type">
						  <option value="Title">Title</option>
						  <option value="Legal">Legal</option>
						  <option value="Market">Market</option>
						  <option value="Liquidity">Liquidity</option>
						  <option value="Income">Income</option>
						  <option value="Construction">Construction</option>
						  <option value="Developer">Developer</option>
						  <option value="Auction">Auction</option>
						  <option value="Redemption">Redemption</option>
						  <option value="Occupancy">Occupancy</option>
						  <option value="Repair">Repair</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_1`]} placeholder="Income Risk Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_2`]} placeholder="Construction Risk Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_3`]} placeholder="Developer Risk Percentage"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4`]} data-search={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4" type="text" onChange={(ev) => SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4_Change(ev, i)} className="form-control" value={e[`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_3_4`]} placeholder="Auction Risk Percentage"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Risk Explanation`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Risk Explanation`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0" type="text" className="form-control" placeholder="Risk Explanation" value={SALEPROFIT_RISK_SCORE["4"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Risk Explanation`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0" type="text" className="form-control" placeholder="Submitted By" value={SALEPROFIT_RISK_SCORE["5"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1" type="text" className="form-control" placeholder="Submitted At" value={SALEPROFIT_RISK_SCORE["5"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2" type="text" className="form-control" placeholder="Reviewed By" value={SALEPROFIT_RISK_SCORE["5"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3" type="text" className="form-control" placeholder="Reviewed At" value={SALEPROFIT_RISK_SCORE["5"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4"  value={SALEPROFIT_RISK_SCORE["5"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5" type="text" className="form-control" placeholder="Approval Notes" value={SALEPROFIT_RISK_SCORE["5"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0"  value={SALEPROFIT_RISK_SCORE["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0`]} onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1" type="text" className="form-control" placeholder="Created By" value={SALEPROFIT_RISK_SCORE["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2" type="text" className="form-control" placeholder="Created At" value={SALEPROFIT_RISK_SCORE["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3" type="text" className="form-control" placeholder="Updated By" value={SALEPROFIT_RISK_SCORE["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4" type="text" className="form-control" placeholder="Updated At" value={SALEPROFIT_RISK_SCORE["9"][`SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4`]} 
						onChange={SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["SALE_PROFIT_02_OFFERING_LEGAL_COMPLIANCE_READINESS_SALEPROFIT_RISK_SCORE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default SALEPROFIT_Risk_Score;  